import React, { Component } from 'react';
import styles from './PageToolbarSeparator.css';

class PageToolbarSeparator extends Component {

  //
  // Render

  render() {
    return (
      <div className={styles.separator} />
    );
  }

}

export default PageToolbarSeparator;
